import {defineAsyncComponent} from 'vue';

const DownloadDataPopup = defineAsyncComponent(() => import('@/views/system/DownloadDataPopup.vue'));

const CreateDownloadUserPopup = defineAsyncComponent(() => import('@/views/system/CreateDownloadUserPopup.vue'));

export function systemRegister(app) {
  app.component('DownloadDataPopup', DownloadDataPopup);
  app.component('CreateDownloadUserPopup', CreateDownloadUserPopup);
}
